(() => {
  'use strict';
  if (window.__plProductTabsDemand) return;
  window.__plProductTabsDemand = true;
  const mounted = new WeakMap();
function mount(section){

  'use strict';

  if (mounted.has(section)) return;
  var lifecycle = new AbortController();
  var pending = new Map();
  mounted.set(section, lifecycle);

  if (!section) return;



  /* ---------- Tab switching ---------- */

  var tabBtns = section.querySelectorAll('[data-pl-pt-tab]');

  var panels = section.querySelectorAll('[data-pl-pt-panel]');



  var tabsNav = section.querySelector('[data-pl-pt-tabs]');



  function activateTab(index){

    tabBtns.forEach(function(b){

      var on = b.dataset.plPtTab === String(index);

      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;

      if (on && tabsNav && tabsNav.scrollWidth > tabsNav.clientWidth) {

        var left = b.offsetLeft - (tabsNav.clientWidth - b.offsetWidth) / 2;

        tabsNav.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });

      }

    });

    panels.forEach(function(p){

      var on = p.dataset.plPtPanel === String(index);

      if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }

      if (on) { updateArrowsFor(p); ensurePanel(p); }

    });

  }

  tabBtns.forEach(function(b){

    b.addEventListener('click', function(){ activateTab(b.dataset.plPtTab); });
    b.addEventListener('keydown', function(event){
      var keys = ['ArrowLeft','ArrowRight','Home','End'];
      if (keys.indexOf(event.key) === -1) return;
      event.preventDefault();
      var index = Array.prototype.indexOf.call(tabBtns,b);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabBtns.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabBtns.length) % tabBtns.length;
      tabBtns[index].focus(); activateTab(tabBtns[index].dataset.plPtTab);
    });

  });



  /* Shopify design mode: jump to the tab containing a selected block */

  if (window.Shopify && Shopify.designMode) {

    document.addEventListener('shopify:block:select', function(e){

      var panel = e.target.closest('[data-pl-pt-panel]');

      if (panel && section.contains(panel)) activateTab(panel.dataset.plPtPanel);

    }, {signal:lifecycle.signal});

  }



  /* ---------- Arrows + native scroll (per panel) ---------- */

  function updateArrowsFor(panel){

    var track = panel.querySelector('[data-pl-pt-track]');

    var viewport = panel.querySelector('[data-pl-pt-viewport]');

    var prev = panel.querySelector('[data-pl-pt-prev]');

    var next = panel.querySelector('[data-pl-pt-next]');

    if (!track || !viewport) return;

    var overflowing = track.scrollWidth > track.clientWidth + 2;

    viewport.dataset.overflowing = overflowing ? 'true' : 'false';

    if (!overflowing) { prev.classList.remove('is-visible'); next.classList.remove('is-visible'); return; }

    var atStart = track.scrollLeft <= 2;

    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

    prev.classList.toggle('is-visible', !atStart);

    next.classList.toggle('is-visible', !atEnd);

  }



  function scrollByCard(track, dir){

    var card = track.querySelector('.pl-pt__item');

    if (!card) return;

    var step = (card.getBoundingClientRect().width + parseInt(getComputedStyle(track).columnGap || '12', 10)) * dir;

    track.scrollBy({ left: step, behavior: 'smooth' });

  }



  function bindPanel(panel){
    var track = panel.querySelector('[data-pl-pt-track]');
    if (!track || track.dataset.plPtBound === 'true') return;
    track.dataset.plPtBound = 'true';

    var prev = panel.querySelector('[data-pl-pt-prev]');

    var next = panel.querySelector('[data-pl-pt-next]');

    if (prev) prev.addEventListener('click', function(){ scrollByCard(track, -1); });

    if (next) next.addEventListener('click', function(){ scrollByCard(track, 1); });

    if (track) track.addEventListener('scroll', function(){ updateArrowsFor(panel); }, { passive: true });
    panel.querySelectorAll('img').forEach(function(image){ image.addEventListener('load',function(){ updateArrowsFor(panel); }); });
  }

  window.addEventListener('resize', function(){

    panels.forEach(function(p){ if (!p.hasAttribute('hidden')) updateArrowsFor(p); });

  }, {signal:lifecycle.signal});

  /* Initial arrow state for the visible panel */

  panels.forEach(function(p){ if (!p.hasAttribute('hidden')) updateArrowsFor(p); });



  /* ---------- Per-card: toggle + frequency + add to cart ---------- */

  function bindCards(scope){
  var cards = scope.querySelectorAll('[data-pl-pt-card]');

  cards.forEach(function(card){
    if (card.dataset.plPtBound === 'true') return;
    card.dataset.plPtBound = 'true';

    var toggleBtns = card.querySelectorAll('[data-pl-pt-toggle]');

    var freqSelect = card.querySelector('[data-pl-pt-freq]');

    var badgeEl = card.querySelector('[data-pl-pt-save-badge]');

    var atc = card.querySelector('[data-pl-pt-atc]');

    var autoshipPriceEl = card.querySelector('[data-pl-pt-autoship-price]');

    var autoshipLabelEl = card.querySelector('[data-pl-pt-autoship-label]');



    function getMode(){ return card.dataset.mode || 'onetime'; }

    function setMode(m){
      if (card.dataset.mode === m) return;
      card.classList.remove('pl-pt__card--autoship-enter');
      card.dataset.mode = m;
      if (m === 'autoship') {
        void card.offsetWidth;
        card.classList.add('pl-pt__card--autoship-enter');
      }
    }



    function getActiveSellingPlan(){

      if (getMode() !== 'autoship') return null;

      if (freqSelect) {

        var opt = freqSelect.options[freqSelect.selectedIndex];

        if (!opt) return null;

        return {

          id: opt.value,

          price: parseInt(opt.dataset.price, 10),

          priceFormatted: opt.dataset.priceFormatted,

          discountPct: parseInt(opt.dataset.discountPct, 10) || 0,

          label: opt.dataset.label || ''

        };

      }

      if (!card.dataset.sellingPlanId) return null;

      return {

        id: card.dataset.sellingPlanId,

        price: parseInt(card.dataset.spPrice, 10),

        priceFormatted: card.dataset.spPriceFormatted,

        discountPct: parseInt(card.dataset.spDiscountPct, 10) || 0,

        label: card.dataset.spLabel || ''

      };

    }



    function updateBadge(){

      if (!badgeEl) return;

      var sp = getActiveSellingPlan();

      badgeEl.hidden = !sp || sp.discountPct <= 0;

      if (sp && sp.discountPct > 0) badgeEl.textContent = 'Save ' + sp.discountPct + '%';

    }



    function updateAutoshipDisplay(){

      var sp = getActiveSellingPlan();

      if (!sp) return;

      if (autoshipPriceEl) autoshipPriceEl.textContent = sp.priceFormatted;

      if (autoshipLabelEl) autoshipLabelEl.textContent = sp.label;

    }



    toggleBtns.forEach(function(btn){

      btn.addEventListener('click', function(){

        setMode(btn.dataset.plPtToggle);

        toggleBtns.forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });

        updateBadge();

      });

    });



    if (freqSelect) {

      freqSelect.addEventListener('change', function(){ updateAutoshipDisplay(); updateBadge(); });

    }



    if (atc) {

      atc.addEventListener('click', function(){

        if (atc.disabled) return;

        atc.disabled = true;
        atc.dataset.loading = 'true';

        var sp = getActiveSellingPlan();

        var item = { id: parseInt(card.dataset.variantId, 10), quantity: 1 };

        if (getMode() === 'autoship' && sp) item.selling_plan = parseInt(sp.id, 10);

        fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {

          method: 'POST',

          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

          body: JSON.stringify({ items: [item] })

        })

        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })

        .then(function(){

          var unitPrice = (getMode() === 'autoship' && sp ? sp.price : parseInt(card.dataset.onetimePrice, 10)) / 100;

          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({

            event: 'add_to_cart',

            ecommerce: {

              items: [{

                item_id: card.dataset.productId,

                item_variant: card.dataset.variantId,

                quantity: 1,

                price: unitPrice,

                affiliation: 'pl-product-tabs',

                item_list_name: section.querySelector('[data-pl-pt-demand]').dataset.listName,

                selling_plan: getMode() === 'autoship' && sp ? sp.id : null

              }]

            }

          });

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));

        })

        .catch(function(){ window.location.href = (window.Shopify?.routes?.root || '/') + 'cart'; })

        .finally(function(){ setTimeout(function(){ delete atc.dataset.loading; atc.disabled = false; }, 250); });

      });

    }

  });
  }
  panels.forEach(function(panel){ bindPanel(panel); bindCards(panel); });
  section.addEventListener('click',function(event){
    var retry = event.target.closest('[data-pl-pt-retry]');
    if (retry) ensurePanel(retry.closest('[data-pl-pt-panel]'));
  });
  lifecycle.signal.addEventListener('abort',function(){
    pending.forEach(function(record){ record.controller.abort(); });
    pending.clear();
  });
  async function ensurePanel(panel){
    if (!panel || panel.dataset.plPtLoaded === 'true' || pending.has(panel)) return;
    var source = panel.dataset.plPtSource;
    if (!source) return;
    var controller = new AbortController();
    var timer = setTimeout(function(){ controller.abort(); },15000);
    pending.set(panel,{controller:controller});
    var status = panel.querySelector('[data-pl-pt-load-status]');
    var retry = panel.querySelector('[data-pl-pt-retry]');
    var content = panel.querySelector('[data-pl-pt-content]');
    panel.setAttribute('aria-busy','true');
    if (status) { status.hidden = false; status.textContent = panel.dataset.plPtLoading; }
    if (retry) retry.hidden = true;
    try {
      var url = new URL(source,location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid tab URL');
      var context = new URL(location.href);
      ['preview_theme_id','_fd','pb'].forEach(function(key){
        if (context.searchParams.has(key)) url.searchParams.set(key,context.searchParams.get(key));
      });
      url.searchParams.set('section_id',section.id.replace(/^shopify-section-/,''));
      var response = await fetch(url.href,{credentials:'same-origin',signal:controller.signal,headers:{Accept:'text/html'}});
      if (!response.ok) throw new Error('Tab request failed');
      var doc = new DOMParser().parseFromString(await response.text(),'text/html');
      var incomingSection = doc.getElementById(section.id);
      var incoming = incomingSection && Array.prototype.find.call(incomingSection.querySelectorAll('[data-pl-pt-panel]'),function(candidate){
        return candidate.dataset.plPtBlock === panel.dataset.plPtBlock;
      });
      if (!incoming || incoming.dataset.plPtLoaded !== 'true' || incoming.dataset.plPtSource !== source) throw new Error('Missing tab content');
      var fetched = incoming.querySelector('[data-pl-pt-content]');
      if (!fetched || lifecycle.signal.aborted || !section.isConnected) return;
      content.replaceChildren.apply(content,Array.from(fetched.childNodes));
      panel.dataset.plPtLoaded = 'true';
      bindPanel(panel); bindCards(panel);
      if (status) { status.hidden = true; status.textContent = ''; }
      if (!panel.hidden) requestAnimationFrame(function(){ updateArrowsFor(panel); });
      document.dispatchEvent(new CustomEvent('pl:product-tabs:loaded',{detail:{sectionId:section.id,blockId:panel.dataset.plPtBlock}}));
    } catch(error) {
      if (lifecycle.signal.aborted || !section.isConnected) return;
      if (status) { status.hidden = false; status.textContent = panel.dataset.plPtError; }
      if (retry) retry.hidden = false;
    } finally {
      clearTimeout(timer); pending.delete(panel); panel.removeAttribute('aria-busy');
    }
  }
}

  function init(scope){
    if (scope.matches?.('.pl-section-product-tabs')) mount(scope);
    scope.querySelectorAll('.pl-section-product-tabs').forEach(mount);
  }
  document.addEventListener('shopify:section:load',function(event){ init(event.target); });
  document.addEventListener('shopify:section:unload',function(event){
    var section = event.target.closest('.pl-section-product-tabs');
    if (section) { mounted.get(section)?.abort(); mounted.delete(section); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function(){ init(document); },{once:true});
  else init(document);
})();
